<template>
  <div class="vue-admin-wrap">
    <div>
      <b-modal
      hide-footer
      @hide="cancel"
      id="data-modal"
      :modal-class="myclass">
        <template v-slot:modal-header>
          <span class="close-x" v-on:click="cancel()">×</span>
          <h3>Data</h3>
        </template>
        <div
        class="modal-body-container"
        v-bind:class="{isMobile: isMobile() || isTablet()}">
          <div class="modal-body">
            <div class="menu">
              <ul class="menu-items">
                <li
                class="menu-item"
                v-on:click="showOutageHistoryWorkflow"
                title="Manage Utilities"
                v-bind:class="{selected: workflow === 'outage-history'}">Outage History</li>
                <li
                class="menu-item"
                v-on:click="showOutagesByCountyWorkflow"
                title="Manage Towns"
                v-bind:class="{selected: workflow === 'outages-by-county'}">Outages by County</li>
              </ul>
            </div>
            <div class="content">
              <outage-history :user="user" v-if="workflow === 'outage-history'" />
              <outages-by-utility-and-county v-if="workflow === 'outages-by-county'"/>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import vueMqMixin from "../../../shared/mixins/VueMqMixin";
import OutageHistory from "@/components/shared/outage-history/OutageHistory";
import OutagesByUtilityAndCounty from "@/components/shared/outages-by-utility-and-county/OutagesByUtilityAndCounty";

export default {
  name: 'DataModal',
  mixins: [vueMqMixin],
  props: {
    user: Object,
    hideModal: Function
  },
  components: {
    OutageHistory,
    OutagesByUtilityAndCounty
  },
  data() {
    return {
      workflow: 'outage-history'
    }
  },
  async created() {
    this.myclass = this.isMobile() || this.isTablet() ? ['vt-outages-modal data isMobileOrTablet'] : ['vt-outages-modal data'];
    Vue.nextTick(() => this.$bvModal.show('data-modal'));
  },
  methods: {
      cancel() {
        this.hideModal();
      },
      showOutageHistoryWorkflow() {
        this.workflow = 'outage-history';
      },
      showOutagesByCountyWorkflow() {
        this.workflow = 'outages-by-county';
      },
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/partials/_variables.scss";

.modal-body-container{
  .modal-body{
    .menu{
      .menu-items{
        padding: 0;
        margin: 0;
        list-style: none;
        display: flex;
        justify-content: start;

        .menu-item{
            list-style-type: none;
            width: 25%;
            height: 50px;
            margin: 0 20px 0 0;
            padding: 5px;
            font-weight: 500;
            line-height: 50px;
            color: #fff;
            background-color: $navy;
            text-align: center;

          &:last-child{
            margin-right: 0;
          }

          &:hover{
            cursor: pointer;
            color: #fff;
            background-color: $tealDark;
          }

          &.selected{
            color: $black;
            background-color: $lightGrey;
          }
        }
      }
    }

    .content{
      padding:  20px 20px 50px 20px;
      background-color: $lightGrey;
    }
  }

  &.isMobile{
    .modal-body{
      .menu{
        .menu-items{
          .menu-item{
              width: 45%;
          }
        }
      }

      .content{
        padding:  20px 10px 50px 10px;
        background-color: $lightGrey;
      }
    }
  }
}
</style>
